// extracted by css-extract-rspack-plugin
export default {"container":"fqJmI","header":"kj6CL","loadingContainer":"nXYlR","loadingContent":"JOdIO","errorContainer":"ppZPt","errorContent":"ZgZfM","settingsContent":"dX768","footer":"Ay14B"};